export default (node) => {
  const shipThresholdHour = node.dataset.shipThresholdHour;
  const countdownTitle = node.querySelector('[data-countdown-title]');
  const orderTime = node.querySelector('[data-order-time]');
  const mondayText = node.dataset.mondayText;
  const todayText = node.dataset.todayText;
  const tomorrowText = node.dataset.tomorrowText;

  const getTime = () => {
    const usersCurrentTime = new Date();
    const localizedDate = usersCurrentTime.toLocaleString('en-US', {
      timeZone: 'America/Edmonton',
    });
    const currentDate = new Date(localizedDate);

    const parsedShipThresholdHour = parseInt(shipThresholdHour);
    const currentDay = currentDate.getDay();
    const currentHours = currentDate.getHours();
    const currentMinutes = currentDate.getMinutes();

    const willShipTomorrow = parsedShipThresholdHour + 1 - currentHours <= 0;
    // We will ship
    const willShipMonday =
      (willShipTomorrow && currentDay === 5) ||
      currentDay === 6 ||
      currentDay === 0;
    const isSunday = currentDay === 0;

    const shippingText =
      willShipMonday && !isSunday
        ? mondayText
        : willShipTomorrow || isSunday
          ? tomorrowText
          : todayText;

    countdownTitle.innerHTML = shippingText;

    const timeUntilShipping = { hours: 0, minutes: 0, seconds: 0 };

    // Calculate time until shipping
    if (!willShipMonday && currentHours <= parsedShipThresholdHour) {
      timeUntilShipping.hours = parsedShipThresholdHour - currentHours;
      timeUntilShipping.minutes = 60 - currentMinutes;
      timeUntilShipping.seconds = 60 - currentDate.getSeconds();
    } else {
      timeUntilShipping.hours = 24 - (currentHours - parsedShipThresholdHour);
      timeUntilShipping.minutes = 60 - currentMinutes;
      timeUntilShipping.seconds = 60 - currentDate.getSeconds();
    }

    if (willShipMonday) {
      const daysToMonday = isSunday ? 0 : 7 - currentDay;
      timeUntilShipping.hours += daysToMonday * 24;
    }

    const timeHTML = `<span>${timeUntilShipping.hours}h</span>:<span>${timeUntilShipping.minutes}m</span>:<span>${timeUntilShipping.seconds}s</span>`;
    orderTime.innerHTML = timeHTML;
  };

  const init = () => {
    getTime();
    setInterval(() => {
      getTime();
    }, 1000);
  };

  init();
};
